// Builds the display label for a component, matching the legacy UI
// (e.g. "23 70 CENTRAL HVAC EQUIPMENT"). The API serializes the description
// field as `name` (see ComponentDTO), so prefer `name` and fall back to
// `description` for safety.
export const componentLabel = component => {
    if (!component) return '';
    const label = component.name ?? component.description ?? '';
    return `${component.num ?? ''} ${label}`.trim();
};
